import { render, staticRenderFns } from "./createFM.vue?vue&type=template&id=b7112438&"
import script from "./createFM.vue?vue&type=script&lang=js&"
export * from "./createFM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports